import type { ListingPreview } from "./types";

export function applyListingPreviewToForm(form: HTMLFormElement, preview: ListingPreview) {
  setFormValue(form, "address", preview.address);
  setFormValue(form, "listing_url", preview.listing_url);
  setFormValue(form, "purchase_price", preview.list_price);
  setFormValue(form, "bedrooms", preview.bedrooms);
  setFormValue(form, "bathrooms", preview.bathrooms);
  setFormValue(form, "square_feet", preview.square_feet);
}

export function describeListingPreview(preview: ListingPreview) {
  if (preview.extracted_fields.length === 0) {
    return "No listing facts were found. You can still fill the fields manually.";
  }
  const labels: Record<string, string> = {
    address: "address",
    list_price: "list price",
    bedrooms: "beds",
    bathrooms: "baths",
    square_feet: "square feet",
    status: "listing status",
    image_url: "image",
  };
  const fields = preview.extracted_fields.map((field) => labels[field] ?? field).join(", ");
  return `Imported ${fields}.`;
}

function setFormValue(form: HTMLFormElement, name: string, value: string | number | null | undefined) {
  if (value === null || value === undefined || value === "") return;
  const element = form.elements.namedItem(name);
  if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
    element.value = String(value);
  }
}
